var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 13.3594H2.03584C0.913242 13.3594 0 12.4461 0 11.3235V5.08272C0 3.96012 0.913242 3.04688 2.03584 3.04688H8.27666C9.39926 3.04688 10.3125 3.96012 10.3125 5.08272V11.3235C10.3125 12.4461 9.39926 13.3594 8.27666 13.3594ZM2.03584 4.92188C1.94713 4.92188 1.875 4.994 1.875 5.08272V11.3235C1.875 11.4122 1.94713 11.4844 2.03584 11.4844H8.27666C8.36537 11.4844 8.4375 11.4122 8.4375 11.3235V5.08272C8.4375 4.994 8.36537 4.92188 8.27666 4.92188H2.03584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 26.9531H2.03584C0.913242 26.9531 0 26.0399 0 24.9173V18.6765C0 17.5539 0.913242 16.6406 2.03584 16.6406H8.27666C9.39926 16.6406 10.3125 17.5539 10.3125 18.6765V24.9173C10.3125 26.0399 9.39926 26.9531 8.27666 26.9531ZM2.03584 18.5156C1.94713 18.5156 1.875 18.5878 1.875 18.6765V24.9173C1.875 25.006 1.94713 25.0781 2.03584 25.0781H8.27666C8.36537 25.0781 8.4375 25.006 8.4375 24.9173V18.6765C8.4375 18.5878 8.36537 18.5156 8.27666 18.5156H2.03584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 7.73438H14.0625C13.5448 7.73438 13.125 7.31461 13.125 6.79688C13.125 6.27914 13.5448 5.85938 14.0625 5.85938H29.0625C29.5802 5.85938 30 6.27914 30 6.79688C30 7.31461 29.5802 7.73438 29.0625 7.73438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 11.25H14.0625C13.5448 11.25 13.125 10.8302 13.125 10.3125C13.125 9.79477 13.5448 9.375 14.0625 9.375H23.9062C24.424 9.375 24.8438 9.79477 24.8438 10.3125C24.8438 10.8302 24.424 11.25 23.9062 11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 21.0938H14.0625C13.5448 21.0938 13.125 20.674 13.125 20.1562C13.125 19.6385 13.5448 19.2188 14.0625 19.2188H29.0625C29.5802 19.2188 30 19.6385 30 20.1562C30 20.674 29.5802 21.0938 29.0625 21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 24.8438H14.0625C13.5448 24.8438 13.125 24.424 13.125 23.9062C13.125 23.3885 13.5448 22.9688 14.0625 22.9688H23.9062C24.424 22.9688 24.8438 23.3885 24.8438 23.9062C24.8438 24.424 24.424 24.8438 23.9062 24.8438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b12dfb5d5343e27bfb65573b1980132c.svg";
export { ForwardRef as ReactComponent };